module.exports = __webpack_public_path__ + "static/img/c.e7c858b9.png";